export const messenger = {
  postMessage: (key, message) => {
    window?.ReactNativeWebView?.postMessage?.(
      JSON.stringify({ key, payload: message })
    );
  },
};
